import { ToastyService } from 'ng2-toasty';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DiscountService } from '../../Services/discount.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-member-discount-form',
  template: require('./member-discount-form.component.html'),
  styles: [require('./member-discount-form.component.css')]
})
export class MemberDiscountFormComponent implements OnInit {

  
  discount: any = {}
  constructor(private router: Router,
    private route: ActivatedRoute,
    private toastyService: ToastyService,
    private discountService: DiscountService) {

    route.params.subscribe(p => {
      if (p['id'])
        this.discount.id = +p['id'];
      else
        this.discount.id = 0;
    });


  }

  ngOnInit() {
     if (this.discount.id > 0) {
      this.discountService.getDiscountById(this.discount.id).subscribe(
        g => {
          this.discount = g;
          // console.log(this.group);
        }, err => {
          if (err.status == 404)
            // this.router.navigate(['/home']);
            console.log(err);
            console.log(this.discount.id);
        });

    }
  }

  submit(){
    // console.log("Discount: "+ JSON.stringify(this.discount));
    if (this.discount.id > 0){
      this.discountService.updateDiscountById(this.discount).subscribe( d =>{
        // console.log("Discount saved: "+ JSON.stringify(this.discount));
        this.router.navigate(['/discounts/list']);    
      });

    }else{
      this.discountService.createDiscount(this.discount).subscribe( d=>{
        // console.log("Discount created: "+JSON.stringify(d));
        this.router.navigate(['/discounts/list']);
      });
    }  
  }

  deleteDiscount(){
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je deze korting wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.discountService.delete(this.discount.id).subscribe(x => {
            this.router.navigate(['/discounts/list']);
          });
        }
      });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-discount-form/member-discount-form.component.ts